var _defs, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoww(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.73,
    height: 36.69,
    viewBox: "0 0 141.73 56.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_39",
    "data-name": "Unbenannter Verlauf 39",
    cx: 33.89,
    cy: 32.91,
    fx: 33.89,
    fy: 32.91,
    r: 14.22,
    gradientTransform: "translate(-5.86 49.1) rotate(-60) scale(1 .8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec906"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#fdc406"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fbb808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f8a30b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#f38610"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ed6115"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6331c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6331d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Unbenannter_Verlauf_58",
    "data-name": "Unbenannter Verlauf 58",
    cx: 10.68,
    cy: 42.07,
    fx: 10.68,
    fy: 42.07,
    r: 26.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6331d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#b62c1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#411b15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151514"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#fec906",
    d: "M34.44,35.8c-.43,0-.86-.15-1.22-.45-.71-.6-2.18-2.36-.39-5.59,1.29-2.34,4.06-5,7.78-7.47,4.15-2.76,9.22-5.12,14.65-6.81,9.9-3.09,25.77-5.5,45.1.6.99.31,1.54,1.37,1.23,2.36-.31.99-1.37,1.54-2.36,1.23-12.38-3.91-25.2-4.64-37.05-2.11-8.84,1.88-17.3,5.7-22.62,10.21-3.12,2.64-3.78,4.34-3.81,4.8.71.68.77,1.81.13,2.57-.37.44-.9.67-1.44.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    fill: "#0e0f0e",
    d: "M64.75,21.9c-1.22,0-2.22.99-2.22,2.22v16.38l-14.77-17.79c-.41-.49-1.02-.8-1.71-.8-1.22,0-2.22.99-2.22,2.22v22.52c0,1.22.99,2.22,2.22,2.22s2.22-.99,2.22-2.22v-16.38l14.77,17.79c.41.49,1.02.8,1.71.8,1.22,0,2.22-.99,2.22-2.22v-22.52c0-1.22-.99-2.22-2.22-2.22Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    fill: "#0e0f0e",
    d: "M85.1,21.21c-8.42,0-13.44,5.3-13.44,14.16,0,4.17,1.11,7.66,3.22,10.09,2.34,2.69,5.78,4.06,10.22,4.07,4.44,0,7.88-1.37,10.22-4.07,2.11-2.43,3.22-5.92,3.22-10.09,0-8.86-5.02-14.15-13.44-14.16ZM85.1,45.62c-6.04,0-8.85-3.27-8.85-10.26s2.81-10.25,8.85-10.26c6.04,0,8.85,3.27,8.85,10.26s-2.81,10.25-8.85,10.26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "url(#Unbenannter_Verlauf_39)",
    d: "M10.88,44.85c-.38,0-.77-.12-1.1-.35-2-1.43-2.91-3.48-2.65-5.91.51-4.71,5.38-9.79,9.37-13.21,4.99-4.28,11.39-8.31,17.12-10.79,5.09-2.2,11.98-4.21,15.89-1.27,2.23,1.68,3.19,4.11,2.77,7.03-.88,6.16-7.89,13.34-13.35,15.41-2.99,1.14-4.76.41-5.72-.4-.79-.67-.89-1.86-.22-2.65.67-.79,1.86-.89,2.65-.22.11.09.68.23,1.95-.25,5.14-1.95,10.41-8.57,10.96-12.42.22-1.54-.2-2.65-1.31-3.49-1.86-1.41-6.39-.76-12.12,1.72-11.64,5.04-23.65,15.42-24.25,20.96-.12,1.08.21,1.81,1.1,2.45.84.61,1.04,1.78.43,2.63-.37.51-.94.78-1.53.78Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "url(#Unbenannter_Verlauf_58)",
    d: "M13.52,45.71c-1.58,0-2.82-.55-3.74-1.21-.84-.61-1.04-1.78-.43-2.63.61-.84,1.78-1.04,2.63-.43,1.3.93,3.16.54,5.53-1.17,3.58-2.57,7.77-7.91,10.94-13.93,3.43-6.52,4.37-11.35,3.79-13.24-.29-.94-.8-1.53-1.62-1.88-3.14-1.32-9.45,1.24-11.41,2.24-.93.47-2.06.1-2.53-.82-.47-.93-.1-2.06.82-2.53.93-.48,9.29-4.59,14.59-2.35,1.84.78,3.14,2.24,3.75,4.24,1.47,4.77-2.34,12.85-4.05,16.1-3.47,6.6-7.98,12.3-12.07,15.24-2.46,1.77-4.51,2.39-6.19,2.39Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    fill: "#0e0f0e",
    d: "M133.17,22.01c-1.16-.38-2.42.26-2.79,1.42l-5.2,16.01-5.2-16.01c-.3-.94-1.18-1.53-2.11-1.53-.94,0-1.81.59-2.11,1.53l-5.2,16.01-5.2-16.01c-.38-1.16-1.63-1.8-2.79-1.42-1.16.38-1.8,1.63-1.42,2.79l7.33,22.51c.19.61.64,1.13,1.26,1.38,1.2.48,2.54-.16,2.93-1.37l5.21-16.03,5.21,16.03c.39,1.21,1.73,1.85,2.93,1.37.63-.25,1.07-.77,1.26-1.38l7.33-22.51c.38-1.16-.26-2.42-1.42-2.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoww);
export default __webpack_public_path__ + "static/media/NOWW.a36df5b982008c65cb707b5105e48736.svg";
export { ForwardRef as ReactComponent };